// Action Types

/**
 * createTypes is a function to create CONSTANT action types instead of regular strings to prevent typo mistakes.
 * @param  {array} strings
 */
function createTypes(strings, ...types) {
  types = [...strings, types];
  types = types.join("\n");
  types = types.split("\n");
  const TYPES = {};
  for (let type of types) {
    if (type === "") {
      continue;
    }
    TYPES[type] = type;
  }
  return TYPES;
}

/**
 * createOurSteps is a function to create the four types for given action.
 * @method
 * @param {string} PREFEX - The PREFEX for each generated type.
 */
function createSteps(PREFEX) {
  const OUR_STEPS = ["loading", "success", "fail"];

  const OUR_STEP_CREATED = [PREFEX.toUpperCase()];

  OUR_STEPS.forEach((STEP) =>
    OUR_STEP_CREATED.push(`${PREFEX}_${STEP}`.toUpperCase())
  );

  return OUR_STEP_CREATED.join("\n");
}

const types = [
  "GET_USER_DATA",
  "UPDATE_USER_PLANS",
  "SET_USER_VIEW"
];

export default createTypes`${types.map(createSteps).join("\n")}`;

export const CLEAR_UPDATE_USER_PLANS_SUCCESS = "CLEAR_UPDATE_USER_PLANS_SUCCESS";
export const CLEAR_SET_USER_VIEW_SUCCESS = "CLEAR_SET_USER_VIEW_SUCCESS";
